<svg width="15" height="15" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_3528_11076" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_3528_11076)">
        <path d="M11.0994 3.30859L11.9314 4.13965L12.1082 4.31641L5.57104 10.8535L1.89233 7.1748L3.0769 5.99023L5.57007 8.4834L10.7458 3.30859L10.9226 3.13184L11.0994 3.30859Z" fill="white" stroke="white" stroke-width="0.5"/>
    </g>
</svg>
